/** Canonical time range options — Real-time first, then ascending window size */
export const HEALTH_TIME_RANGE_OPTIONS = [
  { value: "realtime", label: "Real-time" },
  { value: "24h", label: "24h" },
  { value: "7d", label: "7d" },
  { value: "30d", label: "30d" },
] as const;

/** Chart-specific time range options — ascending duration */
export const CHART_TIME_RANGE_OPTIONS = [
  { value: "1h", label: "1h" },
  { value: "6h", label: "6h" },
  { value: "24h", label: "24h" },
  { value: "7d", label: "7d" },
  { value: "30d", label: "30d" },
] as const;
